export const CTA = Object.freeze({
  buyNow: 'buy.now',
  addPaymentMethod: 'add.payment.method',
  editPaymentMethod: 'edit.payment.method',
  deletePaymentMethod: 'delete.payment.method',
});

export const Section = Object.freeze({
  modifyPaymentMethod: 'modify.payment.method',
});
